import {BaseService} from './baseService.js';
import {SessionStorageUtil} from '../utils/browserStorageSanitizer.js';

/* 
 * Handles interaction with the application api
 */
export class ApplicationService extends BaseService {

	constructor() {	
		super();
		this.currentVersion = null;
	}
	
	async testRegex(testModel) {
		var results = await this.makePOSTRequest('/api/service/application/regex-test', testModel);
		return results;
	}

	async testTransformChain(testModel) {
		var results = await this.makePOSTRequest('/api/service/application/transform-chain-test', testModel);
		return results;
	}

	async getTransformChainInstructions() {
		var results = await this.makeGETRequest('/api/service/application/transform-chain-instructions');
		return results;
	}
	
	async getCurrentVersion() {
		
		if (!this.currentVersion) {
			var text = await this.makeGETRequest("/api/service/application/version", true);
			this.currentVersion = text;			
		}	
		return this.currentVersion;
	}

	/**
	 * Always hits the server for the live app version. Returns null on failure
	 * without surfacing error toasts (safe for background polling during rollout).
	 */
	async pollApplicationVersion() {
		try {
			var headers = {
				'X-Requested-With': 'XMLHttpRequest'
			};
			var workingCompanyId = SessionStorageUtil.getItem('workingCompany');
			if (workingCompanyId) {
				headers['Company'] = workingCompanyId;
			}
			var response = await fetch('/api/service/application/version', {
				credentials: 'same-origin',
				cache: 'no-store',
				headers: headers
			});
			if (!response.ok) {
				return null;
			}
			var text = await response.text();
			if (!text) {
				return null;
			}
			return text.trim();
		} catch (error) {
			return null;
		}
	}
	
	async getAppProperties() {
		var props = await this.makeGETRequest('/api/service/application/app-properties');		
		return props;		
	}
	
	async getAvailableAppPropertiesKey() {
		var keys = await this.makeGETRequest('/api/service/application/app-properties/avaliable-keys');		
		return keys;		
	}	
	
	async saveAppProperties(property) {
		var propertySaved = await this.makePOSTRequest('/api/service/application/app-properties', property);
		return propertySaved;		
	}

	async deleteAppProperties(key) {
		var result = await this.makeDELETERequest('/api/service/application/app-properties/' + key);
		return result;		
	}
	
	async getAppInitStatuses() {
		var statuses = await this.makeGETRequest('/api/service/application/initstatuses');		
		return statuses;		
	}
	
	async runInitStatus(processKey) {
		var status = await this.makePUTRequest('/api/service/application/initstatuses/' + processKey + '/run');		
		return status;		
	}	

	async deleteInitStatus(processKey) {
		var result = await this.makeDELETERequest('/api/service/application/initstatuses/' + processKey);
		return result;		
	}
	
	async getLogRecords(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var events = await this.makeGETRequest('/api/service/application/logrecords' + params);
		return events;		
	}

	exportLogRecords(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/service/application/logrecords/export' + params);
	}

	async deleteAllLogRecords() {
		var result = await this.makeDELETERequest('/api/service/application/logrecords');
		return result;		
	}

	async getLogLevels() {
		var records = await this.makeGETRequest('/api/service/application/loglevels');		
		return records;		
	}
	
	async getSystemStats(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/system-statistics' + params);
		return data;		
	}

	exportSystemStats(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/system-statistics/export' + params);
	}

	async validateCron(checkExpression) {
		var validationData = await this.makePOSTRequest('/api/service/application/validate-cron', checkExpression);
		return validationData;
	}

};

